import ChevronR from 'assets/icons/chevron-r.svg';
import LinkButton from 'components/controls/links/link-button';
import RedundantLink from 'components/accesibility/redundant-link';
import styles from 'components/promos/promos.module.scss';
import cardStyles from './event-promo-card.module.scss';
import { useLocale, useTranslations } from 'next-intl';
import { type IEvent } from 'lib/search/eventSearch';
import cn from 'classnames';
import Image from 'next/image';
import SafeHtml from 'components/safe-html';
import { formatMetDate } from 'helpers/date-time';
import { formatNycTime } from 'lib/visit/locationSchedule';
import { ensureEngageLocale } from 'lib/engage';
import hoverStyles from '../../cards/hover-state.module.scss';
import { getActionAttributes } from 'lib/analytics/analyticsAttributes';

export interface IProps {
	event: IEvent;
	isReversed?: boolean;
}

const EventPromoCard = ({ event, isReversed }: IProps) => {
	const locale = useLocale();
	const t = useTranslations();

	const {
		aceId,
		title,
		url,
		teaserImageUrl,
		teaserImageAltText,
		teaserText,
		startDate,
		buildingName,
		headerCtaText,
	} = event;

	const analyticsAttributes = getActionAttributes({
		contentType: 'event',
		contentId: aceId,
		contentName: title,
	});

	const time = formatNycTime({
		date: new Date(startDate),
		locale,
		short: true,
	});
	const date = formatMetDate(startDate, locale);

	return (
		<div
			key={title}
			className={cn(
				styles.promo,
				isReversed && styles.reversed,
				hoverStyles.card,
			)}
		>
			<div className={styles.imageWrapper}>
				<RedundantLink
					href={ensureEngageLocale(url, locale)}
					{...analyticsAttributes}
				/>
				<figure className={cardStyles.figure}>
					{teaserImageUrl && (
						<div className={cardStyles.imageWrapper}>
							<Image
								src={teaserImageUrl}
								alt={teaserImageAltText}
								fill={true}
								sizes={'(max-width: 960px) 90vw, 50vw'}
							/>
						</div>
					)}
				</figure>
			</div>
			<div className={styles.copyWrapper}>
				<div className={styles.copy}>
					<h3 className={styles.title}>{title}</h3>
					<div className={styles.bodyText}>
						<div className={cardStyles.description}>
							<SafeHtml>{teaserText}</SafeHtml>
						</div>
						<div className={cardStyles.timeAndPlace}>
							<span>{date}</span> <span>{time}</span>
							<span>{buildingName}</span>
						</div>
					</div>
					<LinkButton
						href={ensureEngageLocale(url, locale)}
						rightIcon={<ChevronR />}
						text={headerCtaText || t('readMore')}
						{...analyticsAttributes}
					/>
				</div>
			</div>
		</div>
	);
};

export default EventPromoCard;
